import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';

/* ── Custom SVG Logo Mark ── */
const LogoMark = () => (
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" className="footer-logo-mark">
    <defs>
      <linearGradient id="lm-grad" x1="0" y1="0" x2="36" y2="36" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#2f80ed"/>
        <stop offset="100%" stopColor="#56ccf2"/>
      </linearGradient>
    </defs>
    {/* hexagon outer */}
    <path d="M18 2L32 9.5V26.5L18 34L4 26.5V9.5L18 2Z" stroke="url(#lm-grad)" strokeWidth="1.5" fill="none" opacity="0.6"/>
    {/* hexagon inner */}
    <path d="M18 7L28 12.5V23.5L18 29L8 23.5V12.5L18 7Z" stroke="url(#lm-grad)" strokeWidth="1" fill="rgba(47,128,237,0.08)"/>
    {/* center cross / AI symbol */}
    <line x1="18" y1="11" x2="18" y2="25" stroke="url(#lm-grad)" strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="11" y1="18" x2="25" y2="18" stroke="url(#lm-grad)" strokeWidth="1.5" strokeLinecap="round"/>
    <circle cx="18" cy="18" r="2.5" fill="url(#lm-grad)"/>
    {/* corner dots */}
    <circle cx="18" cy="11" r="1.2" fill="#56ccf2" opacity="0.7"/>
    <circle cx="18" cy="25" r="1.2" fill="#56ccf2" opacity="0.7"/>
    <circle cx="11" cy="18" r="1.2" fill="#2f80ed" opacity="0.7"/>
    <circle cx="25" cy="18" r="1.2" fill="#2f80ed" opacity="0.7"/>
  </svg>
);

/* ── Custom social icons (SVG) ── */
const IconLinkedIn = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/>
    <rect x="2" y="9" width="4" height="12"/>
    <circle cx="4" cy="4" r="2"/>
  </svg>
);
const IconTwitter = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
  </svg>
);
const IconGithub = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0 1 12 6.844a9.59 9.59 0 0 1 2.504.337c1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.02 10.02 0 0 0 22 12.017C22 6.484 17.522 2 12 2z"/>
  </svg>
);
const IconYoutube = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
  </svg>
);

/* ── Custom location / contact icons ── */
const IconPin = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
    <circle cx="12" cy="10" r="3"/>
  </svg>
);
const IconPhone = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13.23a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 2.48h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 10.09a16 16 0 0 0 6 6l.72-.72a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 17.92z"/>
  </svg>
);
const IconMail = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
    <polyline points="22,6 12,13 2,6"/>
  </svg>
);
const IconClock = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <polyline points="12 6 12 12 16 14"/>
  </svg>
);
const IconArrow = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12"/>
    <polyline points="12 5 19 12 12 19"/>
  </svg>
);

/* ── Mini wave divider SVG ── */
const WaveDivider = () => (
  <svg viewBox="0 0 1440 56" fill="none" xmlns="http://www.w3.org/2000/svg" className="footer-wave" preserveAspectRatio="none">
    <path d="M0 32C240 -10.6667 480 -10.6667 720 32C960 74.6667 1200 74.6667 1440 32V56H0V32Z" fill="rgba(5,13,26,1)"/>
    <path d="M0 40C240 2.66667 480 2.66667 720 40C960 77.3333 1200 77.3333 1440 40" stroke="rgba(47,128,237,0.15)" strokeWidth="1" fill="none"/>
  </svg>
);

/* ══════════════════════════════════════
   FOOTER
══════════════════════════════════════ */
const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { label: 'Home',     path: '/' },
    { label: 'About',    path: '/about' },
    { label: 'Services', path: '/services' },
    { label: 'Contact',  path: '/contact' },
  ];

  const services = [
    { label: 'AI-Powered SaaS',      path: '/services' },
    { label: 'Cloud Engineering',     path: '/services' },
    { label: 'AI Agents',             path: '/services' },
    { label: 'MLOps & GPU Workloads', path: '/services' },
    { label: 'AIOps & DevOps',        path: '/services' },
    { label: 'Vertical AI Solutions', path: '/services' },
  ];

  const socials = [
    { icon: <IconLinkedIn />, href: 'https://www.linkedin.com/company/incogniflex',  label: 'LinkedIn' },
    { icon: <IconTwitter />,  href: '#twitter',   label: 'Twitter / X' },
    { icon: <IconGithub />,   href: '#github',    label: 'GitHub' },
    { icon: <IconYoutube />,  href: '#youtube',   label: 'YouTube' },
  ];

  const contact = [
    { icon: <IconMail />,  text: 'info@incogniflex.com' },
  ];

  return (
    <footer className="footer">
      {/* wave top edge */}
      <WaveDivider />

      {/* ambient glows */}
      <div className="footer-glow footer-glow-l" aria-hidden />
      <div className="footer-glow footer-glow-r" aria-hidden />

      {/* grid overlay */}
      <div className="footer-grid-bg" aria-hidden />

      <div className="footer-container">

        {/* ══ TOP: brand + links grid (4 columns) ══ */}
        <div className="footer-links-grid">

          {/* Incogniflex Brand */}
          <div className="footer-col">
            <Link to="/" className="footer-logo-link">
              <img 
                src="https://res.cloudinary.com/dwdkccvnz/image/upload/v1772120373/logo_m30til.png"
                alt="incogniflex logo"
                className="footer-logo-img"
              />
            </Link>
            <p className="footer-tagline">
              Where Human Intelligence<br />Meets Artificial Brilliance
            </p>
            <div className="footer-socials">
              {socials.map(s => (
                <a key={s.label} href={s.href} className="social-btn" aria-label={s.label}>
                  {s.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-col">
            <h5 className="footer-col-heading">
              <span className="col-heading-line" />
              Quick Links
            </h5>
            <ul className="footer-list">
              {quickLinks.map(l => (
                <li key={l.path}>
                  <Link to={l.path} className="footer-link">
                    <IconArrow />
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div className="footer-col">
            <h5 className="footer-col-heading">
              <span className="col-heading-line" />
              Services
            </h5>
            <ul className="footer-list">
              {services.map(s => (
                <li key={s.label}>
                  <Link to={s.path} className="footer-link">
                    <IconArrow />
                    {s.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="footer-col">
            <h5 className="footer-col-heading">
              <span className="col-heading-line" />
              Get in Touch
            </h5>
            <ul className="footer-contact-list">
              {contact.map((c, i) => (
                <li key={i} className="contact-item">
                  <span className="contact-icon">{c.icon}</span>
                  <span className="contact-text">{c.text}</span>
                </li>
              ))}
            </ul>

            {/* status badge */}
            <div className="status-badge">
              <span className="status-dot" />
              All systems operational
            </div>
          </div>

        </div>

        {/* ══ BOTTOM BAR ══ */}
        <div className="footer-bottom">
          <p className="footer-copy">
            © {currentYear} <span className="copy-brand">incogniflex</span>. All rights reserved.
          </p>
          <div className="footer-legal-links">
            <a href="#privacy"  className="legal-link">Privacy Policy</a>
            <span className="legal-sep" />
            <a href="#terms"    className="legal-link">Terms of Service</a>
            <span className="legal-sep" />
            <a href="#cookies"  className="legal-link">Cookie Policy</a>
          </div>
          {/* <p className="footer-built">
            Built with <span className="heart">♥</span> &amp; AI
          </p> */}
        </div>

      </div>
    </footer>
  );
};

export default Footer;